import styled from 'styled-components'

export const Header = styled.h3`
  align-items: center;
`

export const Container = styled.div`
  padding: 1rem;
  background: #2d60ff;
  border-radius: 5px;
  text-align: center;
  display: flex;
  align-items: center;
`

export const DropdownBox = styled.div`
  text-align: center;
  padding: 0.75rem 1rem;
  border-radius: 5px;
  font-weight: bold;
  background: #2d60ff;
  color: white;
  text-decoration: none;
  font-size: 1rem;
`

export const Dropdown = styled.select`
  font-weight: bold;
  background: #2d60ff;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  @media (max-width: 768px) {
    width: 100%;
  }
`
export const Option = styled.option`
  background: #fff;
  color: #000;
  text-align: left;
  &:hover {
    background: #2d60ff;
  }
`
